/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Desktop_PlatformsInputs */

const en_mk_desktop_platforms = /** @type {(inputs: Mk_Desktop_PlatformsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The currently available and tested package is Linux x64. Windows and macOS Desktop packages are not yet available as supported releases. Cloud execution remains available through your browser.`)
};

const id_mk_desktop_platforms = /** @type {(inputs: Mk_Desktop_PlatformsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paket yang tersedia dan sudah diuji saat ini adalah Linux x64. Desktop Windows dan macOS belum tersedia sebagai rilis siap pakai. Eksekusi cloud tetap bisa dipakai melalui browser.`)
};

/**
* | output |
* | --- |
* | "The currently available and tested package is Linux x64. Windows and macOS Desktop packages are not yet available as supported releases. Cloud execution rema..." |
*
* @param {Mk_Desktop_PlatformsInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_desktop_platforms = /** @type {((inputs?: Mk_Desktop_PlatformsInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Desktop_PlatformsInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_desktop_platforms(inputs)
	return en_mk_desktop_platforms(inputs)
});